import ApplicationController from 'aura/application-controller';
import { getState, setState, subscribe } from 'aura/variant-state';
export default class ProductController extends ApplicationController {
  start() {
    this.group = this.element.closest('[data-product-group]')?.dataset.productGroup;
    this.productData = null;
    const island = this.element.querySelector('[data-product-data]');
    if (island) {
      try {
        this.productData = JSON.parse(island.textContent);
      } catch {
        return;
      }
    }
    this.group ||= this.productData?.group;
    if (!this.group) return;
    this.cleanup(subscribe(this.group, (state) => this.render(state)));
    this.listen(this.element, 'change', (event) => {
      if (event.target.matches('[name="id"][data-variant-id]'))
        this.select(event.target.value, true);
    });
    if (this.productData) {
      this.listen(window, 'popstate', () =>
        this.select(
          new URL(location.href).searchParams.get('variant') || this.productData.selectedVariantId,
        ),
      );
      const existing = getState(this.group);
      const requested = new URL(location.href).searchParams.get('variant');
      const initial =
        this.productData.variants.find((variant) => variant.id === requested) ||
        this.productData.variants.find((variant) => variant.id === existing?.variant.id) ||
        this.productData.variants.find(
          (variant) => variant.id === this.productData.selectedVariantId,
        ) ||
        this.productData.variants[0];
      if (initial) this.select(initial.id);
    } else if (getState(this.group)) this.render(getState(this.group));
  }
  select(id, updateURL = false) {
    const data = this.productData || getState(this.group);
    const variant = data?.variants?.find((item) => String(item.id) === String(id));
    if (!variant) return;
    if (updateURL && data.url) {
      const url = new URL(location.href);
      const productURL = new URL(data.url, url);
      if (
        url.origin === productURL.origin &&
        url.pathname.replace(/\/$/, '') === productURL.pathname.replace(/\/$/, '')
      ) {
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url);
      }
    }
    setState(this.group, {
      productId: this.productData?.id || data.productId,
      url: data.url,
      variant,
      variants: data.variants,
    });
  }
  render({ variant }) {
    this.element.querySelectorAll('[name="id"]').forEach((input) => {
      if (input.type === 'radio') input.checked = input.value === String(variant.id);
      else if (input.type === 'hidden' || input.tagName === 'SELECT') input.value = variant.id;
    });
    this.element.querySelectorAll('[data-variant-title]').forEach((node) => {
      node.textContent = variant.title;
    });
    for (const [selector, value] of [
      ['[data-product-price]', variant.priceFormatted],
      ['[data-product-compare-price]', variant.compareAtPriceFormatted],
      ['[data-product-saving]', variant.savingFormatted],
    ])
      this.element.querySelectorAll(selector).forEach((node) => {
        const text = document.createElement('template');
        text.innerHTML = value || '';
        node.textContent = text.content.textContent;
      });
    this.element.querySelectorAll('[data-product-sale]').forEach((node) => {
      node.hidden = !(Number(variant.compareAtPrice) > Number(variant.price));
    });
    this.element.querySelectorAll('[data-availability]').forEach((node) => {
      node.textContent = variant.available
        ? node.dataset.availableText || 'Available'
        : node.dataset.unavailableText || 'Sold out';
    });
    this.element.querySelectorAll('[data-add-button]').forEach((button) => {
      button.disabled =
        !variant.available || button.closest('form')?.getAttribute('aria-busy') === 'true';
      button.dataset.variantAvailable = String(variant.available);
      const label = button.querySelector('[data-add-label]');
      if (label)
        label.textContent = variant.available
          ? button.dataset.addText || 'Add to bag'
          : button.dataset.soldOutText || 'Sold out';
    });
    this.element.querySelectorAll('[data-variant-link]').forEach((link) => {
      if (variant.url) link.href = variant.url;
    });
    this.element.querySelectorAll('[data-selected-swatch]').forEach((swatch) => {
      if (variant.swatch) {
        swatch.style.backgroundColor = variant.swatch;
        swatch.style.setProperty('--swatch-colour', variant.swatch);
        swatch.querySelector('img')?.remove();
      }
    });
    this.element.querySelectorAll('[name="quantity"]').forEach((input) => {
      if (!variant.quantityRule) return;
      const min = Number(variant.quantityRule.min) || 1;
      const step = Number(variant.quantityRule.increment) || 1;
      const max = Number(variant.quantityRule.max) || Infinity;
      const current = Number(input.value);
      const bounded = Math.min(max, Math.max(min, Number.isFinite(current) ? current : min));
      input.min = min;
      input.step = step;
      if (Number.isFinite(max)) input.max = max;
      else input.removeAttribute('max');
      // Round down to a permitted increment, retaining the shopper's quantity when valid.
      input.value = String(min + Math.floor((bounded - min) / step) * step);
    });
  }
}
